module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table multi-report-table"
  }, [_c('h2'), _vm._v(" "), _c('table', {
    staticClass: "table is-narrow"
  }, [_c('thead', [_c('tr', _vm._l((_vm.table.config), function(column, key) {
    return (!column.disabled) ? _c('th', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(column.label)
      }
    }) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.table.data), function(product, productIndex) {
    return _vm._l((_vm._.get(product, _vm.table.multiRowPath, 1)), function(multiRowIndex) {
      return _c('tr', {
        key: productIndex + '-' + multiRowIndex,
        class: {
          parentRow: multiRowIndex === 1, childRow: multiRowIndex !== 1, odd: productIndex % 2 === 0, even: productIndex % 2 !== 0
        }
      }, _vm._l((_vm.table.config), function(column, columnIndex) {
        return (multiRowIndex === 1 || (column.path && column.path.includes('[]'))) ? _c('tablefield', {
          key: productIndex + '-' + multiRowIndex + '-' + columnIndex,
          attrs: {
            "column": column,
            "product": product,
            "rowspan": _vm.getRowSpan(multiRowIndex, column, _vm.table, product),
            "secondary-index": multiRowIndex - 1
          }
        }) : _vm._e()
      }), 1)
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c425770"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableMultiReport.vue
// module id = 668
// module chunks = 0